import(/* webpackMode: "eager" */ "/vercel/path1/app/(core)/(other)/(legal)/layout.tsx");
